<template>
  <div class="ManageCohortsDetails">
      <div class="table-responsive margin-Top-3Perc">
        <table class="table table-striped">
          <thead>
            <tr>
              <th class="text-align-center font-size-15px border-right">Cohort Name</th>
              <!-- <th class="text-align-center font-size-15px border-right">Start TS</th>
              <th class="text-align-center font-size-15px border-right">End TS</th> -->
              <th class="text-align-center font-size-15px">Action</th>
            </tr>  
          </thead>
          <tbody>
            <tr v-for="cohortObj in cohortList" :key="cohortObj.CohortId" v-bind:cohortObj = "cohortObj">
               <td class="text-align-center text-valign-middle border-right col-lg-5">{{cohortObj.CohortName}}</td>
               <!-- <td class="text-align-center text-valign-middle border-right col-lg-2">{{cohortObj.StartTS}}</td> 
               <td class="text-align-center text-valign-middle border-right col-lg-2">{{cohortObj.EndTS}}</td> -->
               <td class="text-align-center text-valign-middle col-lg-3">
                <a href="#" class="cursor-pointer" @click="openDetailsOverlay($event,true,cohortObj)"> View </a>|
                <a href="#" class="cursor-pointer" @click="openEditOverlay($event,true,cohortObj)"> Edit </a>|
                <a href="#" class="cursor-pointer" @click="openConfirmationBox($event,true,cohortObj)"> Delete </a>|
                <a href="#" class="cursor-pointer" @click="openViewUserOverlay($event,true,cohortObj)"> Users </a>
              </td> 
            </tr>
          </tbody>
       </table>
      </div>
    <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box>  
    <confirmation-alert v-if="showConfirmationBox" v-bind:dataObj="null" v-bind:prefixString="prefixDeleteCohortString" v-bind:postfixString="postDeleteCohortString" @showConfirmationBox="updateShowConfirmationAlertFlag" @userConfirmation="deleteSelectedCohort"></confirmation-alert>
    <view-cohort-details v-if="openCohortDetailsOverlay" v-bind:cohortObj="selectedCohortObj" v-bind:groupCourseObj="groupCourseObj" @updateDetailsOverlayFlag="updateDetailsOverlay"></view-cohort-details>
    <update-cohort-details v-if="openEditCohortDetailsOverlay" v-bind:cohortObj="selectedCohortObj" @updateEditDetailsOverlayFlag="updateEditDetailsOverlay" @showSpinner="updateShowSpinnerFlag" @refreshCohortList="refreshCohorts"></update-cohort-details>
    <view-enrolled-participant-in-cohort-list v-bind:cohortObj="selectedCohortObj" v-bind:enrolledParticipants="participantList" v-if="viewAssociatedCohortUsersOverlay" @viewParticipantListOverlay="viewParticipantOverlay"></view-enrolled-participant-in-cohort-list>
    <!-- Show Spinner -->
    <div class="animationload" v-show="showSpinner">
      <div class="osahanloading"></div>
    </div>
    <loader></loader>
  </div>
</template>

<script>
import Loader from '@/components/dashboard/Loader'
import { constants } from '@/utils/constants'
import ViewEnrolledParticipantInCohortList from '@/components/ViewEnrolledParticipantsInCohortList'
import { cohortService } from '@/server-util/cohort-service'
import AlertBox from '@/components/AlertOverlay'
import ConfirmationOverlay from '@/components/ConfirmationOverlay'
import ViewCohortDetails from '@/components/ViewCohortDetailsOverlay'
import UpdateCohortDetails from '@/components/UpdateCohortDetailsOverlay'
export default {
  props: ['cohortList', 'selectedGroupCourseObj'],
  data: function () {
    return {
      selectedCohortObj: null,
      openCohortDetailsOverlay: false,
      openEditCohortDetailsOverlay: false,
      viewAssociatedCohortUsersOverlay: false,
      showSpinner: false,
      showConfirmationBox: false,
      prefixDeleteCohortString: 'Are you sure you want to delete ',
      postDeleteCohortString: '',
      showAlertDialog: false,
      errorMsg: '',
      participantList: []
    }
  },
  methods: {
    openDetailsOverlay: function (event, flagToUpdate, cohortObj) {
      // AK: Open Details Overlay
      this.openCohortDetailsOverlay = flagToUpdate
      // AK: Assign selected Cohort Obj
      this.selectedCohortObj = cohortObj
      // AK: Disabled background scrolling
      this.$store.state.isOverlayVisible = flagToUpdate
    },
    updateDetailsOverlay (value) {
      // AK: Close Details overlay
      this.openCohortDetailsOverlay = value
      // AK: Enable background scrolling
      this.$store.state.isOverlayVisible = value
    },
    openEditOverlay: function (event, flagToUpdate, cohortObj) {
      // AK: Open Edit Details Overlay
      this.openEditCohortDetailsOverlay = flagToUpdate
      // AK: Assign selected Cohort Obj
      this.selectedCohortObj = cohortObj
      // AK: Disabled background scrolling
      this.$store.state.isOverlayVisible = flagToUpdate
    },
    updateEditDetailsOverlay (value) {
      // AK: Close Details overlay
      this.openEditCohortDetailsOverlay = value
      // AK: Enable background scrolling
      this.$store.state.isOverlayVisible = value
    },
    updateShowSpinnerFlag (value) {
      // AK: Show / Hide Spinner on Edit or Delete operation
      // this.showSpinner = value
      this.$store.state.isLoading = value
    },
    refreshCohorts (value) {
      // AK: Refresh Cohort list on successful Delete and Update operation (ManageCohorts File)
      if (value) {
        this.$emit('refreshCohortList', true)
      }
    },
    openConfirmationBox (event, flagToUpdate, cohortObj) {
      this.selectedCohortObj = cohortObj
      this.postDeleteCohortString = '\'' + this.selectedCohortObj.CohortName + '\' cohort?'
      this.showConfirmationBox = true
    },
    deleteSelectedCohort (value) {
      var _this = this
      var storeObj = this.$store
      // AK: Delete Cohort on user selection
      if (value) {
        if (
          this.selectedCohortObj.CohortId !== undefined ||
          this.selectedCohortObj.length > 0
        ) {
          // this.showSpinner = true
          this.$store.state.isLoading = true
          // AK: Hide Delete Confirmation Box
          _this.showConfirmationBox = false
          cohortService
            .deleteCohort(storeObj.state.access_token, _this.selectedCohortObj.CohortId)
            .then(responseObj => {
              if (responseObj.status >= 200 && responseObj.status < 300) {
                // AK: Refresh Cohort List
                _this.$emit('refreshCohortList', true)
                // AK: Hide Spinner
                // this.showSpinner = false
                this.$store.state.isLoading = false
              } else {
                this.showAlertDialog = true
                this.errorMsg = 'Oops! Something went wrong. Please try again.'
                // this.showSpinner = false
                this.$store.state.isLoading = false
              }
            }, errorObj => {
              // AK: Hide Spinner
              // this.showSpinner = false
              this.$store.state.isLoading = false
              this.showAlertDialog = true
              if (errorObj.response === undefined) {
                this.errorMsg = constants.No_Internet_Connection_Msg
              } else {
                this.errorMsg = errorObj.response.statusText
              }
            })
        } else {
          console.log(
            'Selected Cohort Object is NULL hence declined DELETE OPERATION'
          )
        }
      }
    },
    updateShowConfirmationAlertFlag (value) {
      // AK: Used when user pressed close button of delete Cohort overlay
      this.showConfirmationBox = value
    },
    updateShowAlertDialogFlag (value) {
      // AK: Show / hide alert box
      this.showAlertDialog = value
    },
    openViewUserOverlay (event, flagToUpdate, cohortObj) {
      // AK: Assign selected Cohort Obj
      this.selectedCohortObj = cohortObj
      // AK: Get Enrolled Participant List
      this.getEnrolledParticipantsInCohorts()
    },
    viewParticipantOverlay (value) {
      // AK: Used to close the overlay
      this.viewAssociatedCohortUsersOverlay = value
      // AK: Enabled background scrolling
      this.$store.state.isOverlayVisible = value
    },
    getEnrolledParticipantsInCohorts: function () {
      var storeObj = this.$store
      var _this = this
      if (
        this.selectedCohortObj.CohortId !== undefined
      ) {
        // _this.showSpinner = true
        _this.$store.state.isLoading = true
        cohortService
          .getParticipantList(
            storeObj.state.access_token,
            this.selectedCohortObj.CohortId
          )
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              // AK: Hide Spinner after recieving updated Lesson list
              // _this.showSpinner = false
              _this.$store.state.isLoading = false
              if (responseObj.data.length === 0) {
                this.errorMsg = 'No user found in \'' + this.selectedCohortObj.CohortName + '\' cohort.'
                this.showAlertDialog = true
              } else {
                this.participantList = responseObj.data
                // AK: Open View User Overlay
                this.viewAssociatedCohortUsersOverlay = true
                // AK: Disabled background scrolling
                this.$store.state.isOverlayVisible = true
              }
            } else {
              this.showAlertDialog = true
              this.errorMsg = 'Oops! Something went wrong. Please try again.'
              // this.showSpinner = false
              this.$store.state.isLoading = false
            }
          }, errorObj => {
            // AK: Hide Spinner
            // this.showSpinner = false
            this.$store.state.isLoading = false
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          })
      } else {
        console.log(
          'CohortId is NULL hence declined GET PARTICIPANT LIST OPERATION'
        )
      }
    }
  },
  components: {
    'view-cohort-details': ViewCohortDetails,
    'update-cohort-details': UpdateCohortDetails,
    'confirmation-alert': ConfirmationOverlay,
    'alert-box': AlertBox,
    'view-enrolled-participant-in-cohort-list': ViewEnrolledParticipantInCohortList,
    'loader': Loader
  },
  computed: {
    groupCourseObj: {
      get: function () {
        return this.selectedGroupCourseObj
      }
    }
  },
  name: 'ManageCohortsDetails'
}
</script>

<style scoped>
.animationload {
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10000;
}
.osahanloading {
  animation: 1.5s linear 0s normal none infinite running osahanloading;
  background: #fed37f none repeat scroll 0 0;
  border-radius: 50px;
  height: 50px;
  left: 50%;
  margin-left: -25px;
  margin-top: -25px;
  position: absolute;
  top: 50%;
  width: 50px;
}
.osahanloading::after {
  animation: 1.5s linear 0s normal none infinite running osahanloading_after;
  border-color: #85d6de transparent;
  border-radius: 80px;
  border-style: solid;
  border-width: 10px;
  content: "";
  height: 80px;
  left: -15px;
  position: absolute;
  top: -15px;
  width: 80px;
}
@keyframes osahanloading {
  0% {
    transform: rotate(0deg);
  }
  50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.ManageCohortsDetails{
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;

}
.text-align-center {
  text-align: center !important;
}
.text-valign-middle{
  vertical-align: middle;
}
 .margin-Top-3Perc
{
	margin-top: 3% !important;
}
.font-size-15px {
  font-size: 15px !important;
}
.padding-Left-0px {
  padding-left: 0px !important;
}
.padding-right-0px {
  padding-right: 0px !important;
}
.margin-Left-1Point4Perc{
  margin-Left: 1.4%;
}
a:link{
  color: #2c3e50 !important;
  text-decoration: none !important;
} 
a:visited{
  color: #2c3e50 !important;
  text-decoration: none !important;
}
a:hover{
  color: #2c3e50 !important;
  text-decoration: none !important;
}
a:active{
  color: #2c3e50 !important;
  text-decoration: none !important;
}
a{
  color: #2c3e50 !important;
}
.table-striped > tbody > tr:nth-child(2n + 1) > td,
  .table-striped > tbody > tr:nth-child(2n + 1) > th {
  background-color: #ddd;
}
.border-yellow{
  border: 2px solid yellow;
}
.cursor-pointer {
  cursor: pointer;
}
.border-right {
  border-right: 1px solid #aaa !important;
}
.table>thead>tr>th {
    vertical-align: bottom;
    border-bottom: 0px solid #aaaaaa;
}
</style>



// WEBPACK FOOTER //
// src/components/ManageCohortsDetails.vue